import styled, { keyframes } from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ role }) => (role === 'ai' ? 'flex-start' : 'flex-end')};
  padding: ${({ role }) => (role === 'ai' ? '0 80px 0 0' : '0 0 0 80px')};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content; 
  padding: 10px 16px;
  border-radius: ${({ role }) =>
    (role === 'ai' ? '12px 12px 12px 0' : '12px 12px 0 12px')};
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme, role }) =>
    (role === 'ai' ? theme.colors.backgroundLite : theme.colors.background)};
  font-size: 0.95rem;
  line-height: 1.5;
  word-break: break-word;

  /* Markdown styles */
  & p {
    margin: 0.4em 0;
  }

  & strong {
    font-weight: 600;
  }
  & h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    margin-top: 24px;
  }

  & em {
    font-style: italic;
  }

  & code {
    background-color: ${({ theme }) => theme.colors.backgroundLite || '#f5f5f5'};
    color: ${({ theme }) => theme.colors.primary || '#d6336c'};
    font-family: 'Fira Code', monospace;
    font-size: 0.9em;
    padding: 0.15em 0.3em;
    border-radius: 4px;
  }

  & pre {
    background-color: ${({ theme }) => theme.colors.backgroundLite || '#f5f5f5'};
    border: 1px solid ${({ theme }) => `${theme.colors.secondary}50`};
    border-radius: 8px;
    padding: 12px;
    overflow-x: auto;
    font-family: 'Fira Code', monospace;
    font-size: 0.9em;
    margin: 0.5em 0;
  }

  & pre code {
    background: none;
    padding: 0;
    color: ${({ theme }) => theme.colors.primary};
  }

  & ul,
  & ol {
    margin: 0.4em 0 0.4em 1.2em;
  }

  & a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
    &:hover {
      opacity: 0.8;
    }
  }

  & blockquote {
    border-left: 3px solid ${({ theme }) => theme.colors.primary};
    padding-left: 10px;
    margin: 0.5em 0;
    color: ${({ theme }) => theme.colors.secondaryDark};
    font-style: italic;
  }

  & hr {
    border: none;
    border-top: 1px solid ${({ theme }) => theme.colors.backgroundLite || '#e0e0e0'};
    margin: 1em 0;
  }
 
  /* General Table Styling */
  table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0; 
      color: ${({ theme }) => theme.colors.primary};
      border-radius: 12px;
  }

  /* Table Header Styling */
  th {
      background-color:${({ theme }) => theme.colors.secondary};
      border-right: 1px solid ${({ theme }) => theme.colors.backgroundLite}; 
      color: white; /* White text for header */
      padding: 10px;
      text-align: left; /* Align text to the left */
      font-weight: 600;
      font-size: 16px;
  }
  th:last-child {
      border-right: 0; 
  }

  /* Table Data Cell Styling */
  td { 
      padding: 8px; /* Padding for cells */ 
      border-right: 1px solid ${({ theme }) => theme.colors.backgroundLite}; 
      border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundLite}; 
      background-color:${({ theme }) => theme.colors.background};
      font-size: 14px;
  }
  tr td:last-child{
    border-right: 0;
  }
  tr:last-child td{
    border-bottom: 0;
  }
  tr:first-child th:first-child { border-top-left-radius: 10px; }
  tr:first-child th:last-child { border-top-right-radius: 10px; }
 

  tr:last-child td:first-child { border-bottom-left-radius: 10px; }
  tr:last-child td:last-child { border-bottom-right-radius: 10px; }
/*  
  tr:first-child td { border-top-style: solid; }
  tr td:first-child { border-left-style: solid; } */ 
  /* First Row Special Styling (Optional) */ 
`

const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
`

export const Cursor = styled.span`
  display: inline-block;
  width: 2px;
  height: 1em;
  background-color: ${({ theme }) => theme?.colors?.primary};
  margin-left: 2px;
  animation: ${blink} 1s step-start infinite;
  vertical-align: bottom;
`
